import React, { FC } from 'react';
import styled, { css, keyframes } from 'styled-components';

interface LoaderProps {
    loading: boolean;
}

const spin = keyframes`
    to {
        transform: rotate(360deg);

    }

`;

const StyledLoaderWrap = styled.div`
    background-color: rgba(238, 238, 243, 1);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 30px;
    z-index: 200;
`;
const StyledLoader = styled.div`
    ${({ theme }) => css`
        animation: ${spin} 1s linear infinite;
        border: 4px solid ${theme.colors.alt};
        border-top: 4px solid rgba(0, 159, 227, 0.2);
        border-radius: 50%;
        height: 75px;
        width: 75px;
    `}
`;
const StyledLoaderLabel = styled.div`
    ${({ theme }) => css`
        color: ${theme.colors.copy};
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 16px;
        text-align: center;
    `}
`;

const Loader: FC<LoaderProps> = ({ loading }) => {
    if (!loading) {
        return null;
    }
    return (
        <StyledLoaderWrap>
            <StyledLoaderLabel>Locating stockists…</StyledLoaderLabel>
            <StyledLoader />
        </StyledLoaderWrap>
    );
};

export default Loader;
